export default function userDataReceived(userData) {
    return {
        type: userDataReceived.type,
        payload: userData,
    };
}

userDataReceived.type = 'USER_DATA_RECEIVED';
